/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".home-logo[_ngcontent-%COMP%]{margin-bottom:35px}.base-container[_ngcontent-%COMP%]{max-width:960px}"];
export { styles as styles };
